import React from 'react';
import {Spinner} from 'reactstrap';

export default function Loader({color}) {
  return <Spinner color={color || 'light'} />;
}
